import React, { type FC } from 'react';

import { i18nRaw } from '@yandex-int/i18n';
import clx from 'classnames';
import { Link } from 'client/blocks/Link/Link';
import { CloudError } from 'client/types/cloud';
import * as keyset from 'i18n/SmartHomeForm';

import styles from './BackendTypeField.module.scss';

const cloudConsoleUrl = 'https://console.cloud.yandex.ru';

const t = i18nRaw(keyset);

export const getFunctionListErrorMessages = (): Record<CloudError, React.ReactNode> => ({
    [CloudError.FAILED_PRECONDITION]: (
        <>
            <Link className={styles.formElementMargin} to={cloudConsoleUrl} target="_blank">
                <div className={clx(styles.functionValidateErrorLabel, styles.functionValidateErrorLabel_warning)}>
                    {t('cloud-accept')}
                </div>
            </Link>
        </>
    ),
    [CloudError.NOT_FOUND]: (
        <>
            <Link className={styles.formElementMargin} to={cloudConsoleUrl} target="_blank">
                <div className={clx(styles.functionValidateErrorLabel, styles.functionValidateErrorLabel_warning)}>
                    {t('cloud-register')}
                </div>
            </Link>
        </>
    ),
    [CloudError.INTERNAL]: (
        <Link className={styles.formElementMargin} to={`${cloudConsoleUrl}/support`} target="_blank">
            <div className={styles.functionValidateErrorLabel}>{t('cloud-error')}</div>
        </Link>
    ),
    [CloudError.PERMISSION_DENIED]: <div className={styles.functionValidateErrorLabel}>{t('cloud-error-reload')}</div>,
    [CloudError.INVALID_ARGUMENT]: <div className={styles.functionValidateErrorLabel}>{t('cloud-error-reload')}</div>,
    [CloudError.UNAUTHENTICATED]: <div className={styles.functionValidateErrorLabel}>{t('cloud-error-reload')}</div>,
    [CloudError.UNKNOWN]: (
        <Link className={styles.formElementMargin} to={`${cloudConsoleUrl}/support`} target="_blank">
            <div className={styles.functionValidateErrorLabel}>{t('cloud-error')}</div>
        </Link>
    ),
});

const getValidateFunctionDefaultMessage = () => t('cloud-error-access');

export const getValidateFunctionErrorMessages = (): Record<CloudError, React.ReactNode> => ({
    [CloudError.PERMISSION_DENIED]: <>{t('cloud-denied')}</>,
    [CloudError.NOT_FOUND]: (
        <>
            <Link to={cloudConsoleUrl} target="_blank">
                {t('cloud-unavailable')}
            </Link>{' '}
        </>
    ),
    [CloudError.INTERNAL]: getValidateFunctionDefaultMessage(),
    [CloudError.FAILED_PRECONDITION]: getValidateFunctionDefaultMessage(),
    [CloudError.INVALID_ARGUMENT]: getValidateFunctionDefaultMessage(),
    [CloudError.UNAUTHENTICATED]: getValidateFunctionDefaultMessage(),
    [CloudError.UNKNOWN]: getValidateFunctionDefaultMessage(),
});

export const EmptyFunctionsDescription: FC = () => (
    <Link to={cloudConsoleUrl} target="_blank">
        {t('cloud-no-functions')}
    </Link>
);

export const FunctionsDisclaimer: FC = () => <div className={styles.functionDisclaimer}>{t('cloud-tarif')}</div>;
